import { MapTypeStyle } from './map-style.interface';

export const LIGHT_MAP_STYLES: MapTypeStyle[] = [
  { elementType: 'geometry', stylers: [{ color: '#fafafa' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#fafafa' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#707070' }] },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#e7ba54' }]
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#eafaf1' }]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#58d68d' }]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#dddddd' }]
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#cccccc' }]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#919191' }]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ color: '#f4dfb0' }]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#e7ba54' }]
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#c78a00' }]
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{ color: '#e8e8e8' }]
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#db9800' }]
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#bcdefd' }]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#1b6bb2' }]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#e9f5ff' }]
  }
];

export const LIGHT_CIRCLE_OPTIONS = {
  fillColor: '#db9800',   // --color-primary-500
  strokeColor: '#db9800', // --color-primary-500
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillOpacity: 0.2,
};
